export enum ForumLinkTo {
  Product = 'PRODUCT',
  None = 'NONE',
}
